export const translations = {
  en: {
    nav: {
      about: 'About Us',
      services: 'Services',
      team: 'Our Team',
      gallery: 'Gallery',
      contact: 'Contact'
    },
    whatsapp: 'Connect via WhatsApp',
    about: {
      title: 'About Keen Wisdom',
      subtitle: 'Your Trusted Family Office Partner Since 2010',
      description: 'KEEN WISDOM is a premier family office dedicated to providing comprehensive wealth management and strategic advisory services to high-net-worth individuals and families. With expertise in accounting, taxation, investment strategy, and succession planning, we deliver tailored solutions that preserve and grow generational wealth while honoring family values and legacy.'
    },
    overview: {
      title: 'Keen Wisdom Family Succession Advisory Services',
      vision: {
        title: 'Vision & Mission',
        items: [
          'Assist every entrusted family in achieving a smooth succession and passing on their wealth.',
          'Become the most reputable and trusted family succession advisory firm in the Greater Bay Area.',
          'Solving our clients\' challenges is our highest priority.'
        ]
      },
      strengths: {
        title: 'Core Competencies',
        items: [
          'Deep expertise in family succession and inheritance planning.',
          'A team of cross-disciplinary experts.',
          'We provide comprehensive, holistic solutions to high-net-worth families — not financial products.'
        ]
      },
      culture: {
        title: 'Corporate Culture',
        items: [
          'Respect for every partner\'s professional background and abilities.',
          'Innovative thinking to solve client challenges.',
          'Integrity and strict client confidentiality above all.'
        ]
      },
      platform: {
        title: 'Our Signature Client Platform',
        intro: 'We host an exclusive platform offering market-unique experiences for our high-net-worth clients.',
        objectivesTitle: 'Objectives',
        objectives: [
          'Enhance client experience, loyalty, and engagement with Keen Wisdom.',
          'Strengthen incentives and motivation for clients to refer new members.',
          'Increase new membership enrolments and cross-selling opportunities.'
        ],
        circlesTitle: 'Seven Themed Circles for Regular Client Engagement',
        circles: [
          {
            title: 'Culture Circle',
            description: 'Regularly invite mainland university professors and scholars to teach clients Chinese classics, Chinese cultural philosophy, and Eastern & Western management philosophy.'
          },
          {
            title: 'Wellness Circle',
            description: 'Provide clients with premium medical services, regular health check-ups, and health & wellness information.'
          },
          {
            title: 'Wealth Circle',
            description: 'Regularly host wealth forums, inviting China and Hong Kong investment experts to share investment trends and market movements — capturing opportunities while mitigating risks.'
          },
          {
            title: 'Legacy Circle',
            description: 'Invite renowned China and Hong Kong scholars to train next-generation succession skills, discover entrepreneurial spirit, cultivate entrepreneurial qualities, and study successful Eastern & Western business succession cases.'
          },
          {
            title: 'Enterprise Circle',
            description: 'Source startup and private equity investment opportunities for clients and help identify their second career life-curve opportunities.'
          },
          {
            title: 'Arts Circle',
            description: 'Regularly host salon gatherings including music, theatre, antique artefacts, and art appreciation events.'
          },
          {
            title: 'Spirit Circle',
            description: 'Arrange mind-body-spirit retreats promoting positive thinking, improving mental wellbeing, and providing emotional value and volunteer services for family and friends.'
          }
        ]
      }
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive Solutions for Wealth Management',
      items: [
        {
          title: 'Wealth Management',
          description: 'Strategic portfolio management and investment advisory services tailored to your financial goals and risk profile.'
        },
        {
          title: 'Tax Planning & Compliance',
          description: 'Expert tax optimization strategies and compliance services across multiple jurisdictions.'
        },
        {
          title: 'Family Office Services',
          description: 'Comprehensive family office solutions including governance, succession planning, and legacy preservation.'
        },
        {
          title: 'Strategic Advisory',
          description: 'Forward-thinking strategic counsel on business development, investments, and wealth structuring.'
        },
        {
          title: 'Legacy Planning',
          description: 'Thoughtful succession and estate planning that ensures smooth wealth transfer across generations.'
        }
      ]
    },
    team: {
      title: 'Leadership Team',
      subtitle: 'Experienced Professionals Dedicated to Your Success',
      viewBio: 'View Full Biography',
      closeBio: 'Close',
      members: [
        {
          name: 'Wallance Yeung',
          position: 'Founder & CEO',
          bio: 'With over 37 years in the financial services industry, I have accumulated extensive knowledge in finance, particularly in insurance, investments, and family office services. From individual sales to building a sales team of over 100 people, during 23 years in executive positions, I developed decision-making abilities, execution power, strategic thinking, and the ability to collaborate smoothly with different work partners and stakeholders.\n\nPrevious Work Experience:\n1989-1995: Standard Chartered Bank Hong Kong - Retail Banking, Direct Sales Banking Development Manager\n1995-2000: Credit Suisse Group - Senior Business Manager\n2000-2003: CITIC Ka Wah Bank - Assistant Vice President & Bancassurance Business Head\n2003-2018: Sun Life Hong Kong - Senior Executive Partner, Wealth Planning Team\n2019-Present: Keen Wisdom Family Office - Founder & CEO\n\nEducation:\nMBA in Business Management from University of Southern California\nExecutive Diploma in Financial Planning (ExDipFP) from CUHK Asia-Pacific Institute of Business\nExecutive in Agency Management from Hong Kong Management Association\n\nProfessional Expertise:\n• Founding Chairman of Asia-Pacific Family Wealth Legacy Association\n• Former resident instructor for Hong Kong Productivity Council family office courses\n• Approved instructor for HKSAR Government Financial Services Bureau "Pilot Programme for Enhancing Asset and Wealth Management Talent"\n• Family office course instructor at Hong Kong Management Association',
          image: '/wallance-yeung.jpg'
        },
        {
          name: 'Hattie Sun',
          position: 'Chief Strategy Officer',
          bio: 'Hattie is responsible for driving the company\'s strategic development, providing high-net-worth individuals and family clients with forward-looking and pragmatic wealth management and family office solutions.\n\nShe holds a Bachelor\'s degree in Accounting and Finance from the University of Leeds and a Master\'s degree in Professional Accounting from City University of Hong Kong, and is a Certified Public Accountant (HKICPA) and a member of the Institute of Chartered Accountants in England and Wales (ICAEW). Hattie believes in understanding families\' core aspirations with empathy, organically integrating family spirit, cultural values, and wealth management. While safeguarding tax and financial compliance and asset appreciation, she creates family governance and legacy solutions that combine depth with a long-term vision.',
          image: '/hattie-sun.jpg'
        },
        {
          name: 'Bella Man',
          position: 'Chief Operating Officer',
          bio: 'Bella Man has many years of experience in finance, taxation, and corporate operations, and currently serves as Chief Operating Officer. She oversees the company\'s daily operations, internal management, and process optimization to support stable and sustainable business growth.\n\nWith solid experience in financial management, tax planning, corporate operations, and compliance, Bella is skilled at streamlining workflows, coordinating resources, and enhancing operational efficiency. Through her practical and detail-oriented approach, she is committed to building an effective, structured, and sustainable operating environment that supports both business development and client service excellence.',
          image: '/bella-man.jpg'
        },
        {
          name: 'Kit Ngan',
          position: 'Chief Financial Officer',
          bio: 'Kit Ngan is a Certified Practising Accountant of Australia with extensive practical experience in accounting, auditing, and corporate administration. As Chief Financial Officer, she is responsible for the company\'s financial management and related administrative functions, supporting its stable and well-structured development.\n\nWith a strong professional foundation and hands-on experience, Kit is skilled in overseeing financial operations, audit coordination, and corporate administrative matters, and is committed to supporting the company\'s continued growth on an efficient, compliant, and prudent basis.',
          image: '/kit-ngah.jpg'
        }
      ]
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'Let\'s discuss how we can help preserve and grow your family\'s wealth',
      whatsappCTA: 'Start a Conversation on WhatsApp',
      whatsappDesc: 'Connect with our team directly for immediate assistance',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        message: 'Your Message',
        submit: 'Send Message'
      },
      info: {
        title: 'Contact Information',
        whatsapp: 'WhatsApp',
        telephone: 'Telephone',
        email: 'Email',
        emailValue: 'cs@keenwisdom.com',
        address: 'Address',
        addressValue: 'Room 1101, 11/F, 9 Chong Yip Street, Kwun Tong, Kowloon, Hong Kong',
        addressLink: 'https://maps.app.goo.gl/Y6KGYETk5tqS9Nb87',
        telephoneValue: '+852 2805 1278'
      }
    },
    footer: {
      tagline: 'Your Trusted Partner in Family Office Services',
      copyright: '© 2026 KEEN WISDOM. All rights reserved.',
      since: 'Established 2010',
      website: 'www.keenwisdom.com'
    },
    gallery: {
      title: 'Gallery',
      subtitle: 'Moments from Our Legacy Seminars & Events',
      viewImage: 'View',
      playVideo: 'Play Video'
    }
  },
  zh: {
    nav: {
      about: '关于我们',
      services: '服务项目',
      team: '团队成员',
      gallery: '相册',
      contact: '联系我们'
    },
    whatsapp: '通过WhatsApp联系',
    about: {
      title: '关于 Keen Wisdom',
      subtitle: '自2010年以来值得信赖的家族办公室合作伙伴',
      description: '乾慧家族辦公司是一家精品辦公室，致力于为高净值个人及家族提供全面的财富管理及战略咨询服务。凭借在会计、税务、投资策略及传承规划方面的专业知识，我们提供量身定制的解决方案，在尊重家族价值观和传承的同时，保护并增长世代财富。'
    },
    overview: {
      title: '乾慧家族傳承顧問服務',
      vision: {
        title: '企業願景及使命',
        items: [
          '協助每個委託的家族順利接班，傳承財富。',
          '成為大灣區內具口碑及信賴的家族傳承顧問公司。',
          '解決客戶的問題是我們最優先關注的目標。'
        ]
      },
      strengths: {
        title: '核心競爭力',
        items: [
          '我們對家族接班和傳承具深度研究。',
          '團隊成員具跨領域專家。',
          '為國內高淨值家族提供是全方位解決方案，不是金融產品。'
        ]
      },
      culture: {
        title: '企業文化',
        items: [
          '尊重每位合夥人的專業背景和能力。',
          '用創新思維解決客戶的問題。',
          '重視誠信和嚴守客戶的隱私。'
        ]
      },
      platform: {
        title: '乾慧家辦的核心競爭力內涵',
        intro: '成立特別平台為高淨值客戶提供市場獨有活動。',
        objectivesTitle: '目標',
        objectives: [
          '增加客戶對乾慧的良好體驗度、忠誠度和黏度。',
          '增強客戶的轉介新客戶的誘因和動力。',
          '增強新會員入會費和交义銷售服務機率。'
        ],
        circlesTitle: '成立以下七個與客戶定期見面和互動的平台',
        circles: [
          {
            title: '文化薈',
            description: '定期邀請國內大學教授和學者，為高客教授國學、中國文化哲學和東西方管理哲學。'
          },
          {
            title: '養生薈',
            description: '為高客提供高端醫療服務、定期體檢服務和保健養生資訊等。'
          },
          {
            title: '財富薈',
            description: '定期為高客舉辦財富論壇、邀請中港投資專家分享投資趨勢，市場動向，補捉投資機遇，規避風險。'
          },
          {
            title: '傳承薈',
            description: '邀請中港知名學者培訓二代接班能力、發掘企業家精神、培養企業家特質和學習東西方企業的成功企傳承案例。'
          },
          {
            title: '事業薈',
            description: '為高客尋找初創和私募股權的投資機會和為客戶辨識第二事業生命曲線機遇。'
          },
          {
            title: '藝術薈',
            description: '定期為高客舉辦沙龍聚會；包括音樂、戲劇、古董文物和藝術品的觀賞會。'
          },
          {
            title: '心靈薈',
            description: '為高客安排身心靈修聚會，提倡學習正向思維方法，改善心靈健康、為家人朋友提供情緒價值和義工服務。'
          }
        ]
      }
    },
    services: {
      title: '我们的服务',
      subtitle: '全面的财富管理解决方案',
      items: [
        {
          title: '财富管理',
          description: '根据您的财务目标和风险偏好量身定制的战略投资组合管理和投资咨询服务。'
        },
        {
          title: '税务规划与合规',
          description: '跨多个司法管辖区的专业税务优化策略和合规服务。'
        },
        {
          title: '家族办公室服务',
          description: '全面的家族办公室解决方案，包括治理、传承规划和遗产保护。'
        },
        {
          title: '战略咨询',
          description: '关于业务发展、投资和财富架构的前瞻性战略建议。'
        },
        {
          title: '传承规划',
          description: '周到的继承和遗产规划，确保财富在代际之间平稳转移。'
        }
      ]
    },
    team: {
      title: '领导团队',
      subtitle: '致力于您成功的经验丰富的专业人士',
      viewBio: '查看完整简历',
      closeBio: '关闭',
      members: [
        {
          name: 'Wallance Yeung 楊志强',
          position: '创办人及执行长',
          bio: '在超过37年的金融服务业生涯中，我积累了丰富的金融业知识，特别是保险、投资及家族办公室方面的知识，从个人销售到建立超过100多人的销售团队，在达23年的高管岗位，我养成了相关的决策力、行动力、策略性思维与不同的工作伙伴和持份者顺利合作。\n\n过往相关工作经验：\n1989－1995：香港渣打银行 - 零售银行，直销银行业务拓展经理\n1995－2000：瑞士信贷集团 - 瑞士丰泰个人理财有限公司高级业务经理\n2000－2003：中信国际银行 - 零售银行业务部助理副总裁及银保业务主管\n2003－2018：香港永明金融有限公司 - 资产策划团队高级行政合伙人\n2019－现在：乾慧家族管理顾问有限公司 - 创办人及执行长\n\n学历：\n持有美国哥伦比亚南加州大学颁发的企业管理硕士学位(MBA)\n持有香港中文大学亚太工商研究所颁发的理财策划文凭证书ExDipFP\n持有香港管理专业协会颁发的Executive in Agency Management\n\n专业领域：\n• 亚太家族财富传承师学会创会主席\n• 曾任香港生产力促进局家办课程驻导师\n• 香港特区政府财经事务局「提升资产财富管理人才先导计划」认可课程导师\n• Hong Kong Management Association 香港管理学会家办课程导师',
          image: '/wallance-yeung.jpg'
        },
        {
          name: 'Hattie Sun',
          position: 'Chief Strategy Officer（首席战略官）',
          bio: 'Hattie 负责推动公司战略发展，为高净值个人及家族客户提供前瞻且务实的财富管理与家族办公室解决方案。\n\n拥有英国利兹大学金融会计学士及香港城市大学专业会计硕士学位，为香港注册会计师（HKICPA）及英格兰及威尔士特许会计师（ICAEW）。她主张以同理心深入理解家族核心诉求，将家族精神、文化价值观与财富管理有机融合，在保障财税合规与资产增值的同时，打造兼具深度与长远愿景的家族治理与传承方案。',
          image: '/hattie-sun.jpg'
        },
        {
          name: 'Bella Man',
          position: 'Chief Operating Officer（首席运营官）',
          bio: 'Bella Man 拥有多年财务、税务及公司运营管理经验，现任 Chief Operating Officer，负责统筹公司日常营运、内部管理及流程优化，支持业务稳健发展。\n\n她在财务管理、税务规划、企业营运及合规执行方面具备扎实经验，擅长优化流程、整合资源及提升运营效率。凭借务实细致的管理风格，Bella 致力建立高效、有序及可持续的运营体系，为公司发展及客户服务提供坚实支持。',
          image: '/bella-man.jpg'
        },
        {
          name: 'Kit Ngan',
          position: 'Chief Financial Officer（首席财务官）',
          bio: 'Kit Ngan 为澳洲注册会计师，拥有丰富而务实的专业经验，熟悉会计、审计及公司行政管理。现任 Chief Financial Officer，负责公司财务管理及相关行政事务，支持机构稳健及有序发展。\n\n凭借扎实的专业基础及丰富的实务经验，Kit 擅长处理财务运作、审计协调及企业行政管理工作，并致力确保公司在高效、合规及稳健的基础上持续发展。',
          image: '/kit-ngah.jpg'
        }
      ]
    },
    contact: {
      title: '联系我们',
      subtitle: '让我们讨论如何帮助保护和增长您家族的财富',
      whatsappCTA: '在WhatsApp上开始对话',
      whatsappDesc: '直接与我们的团队联系以获得即时帮助',
      form: {
        name: '姓名',
        email: '电子邮箱',
        phone: '电话号码',
        message: '您的留言',
        submit: '发送消息'
      },
      info: {
        title: '联系信息',
        whatsapp: 'WhatsApp',
        telephone: '电话',
        email: '电子邮箱',
        emailValue: 'cs@keenwisdom.com',
        address: '地址',
        addressValue: '香港九龍觀塘創業街9號11樓1101室',
        addressLink: 'https://maps.app.goo.gl/Y6KGYETk5tqS9Nb87',
        telephoneValue: '+852 2805 1278'
      }
    },
    footer: {
      tagline: '您值得信赖的家族办公室服务合作伙伴',
      copyright: '© 2026 KEEN WISDOM. 版权所有。',
      since: '成立于2010年',
      website: 'www.keenwisdom.com'
    },
    gallery: {
      title: '相册',
      subtitle: '传承聚会与活动精彩瞬间',
      viewImage: '查看',
      playVideo: '播放视频'
    }
  }
};